<template>
  <div>
    <b-row align-h="end" class="m-0 p-0 full-width slide-right">
      <b-col cols="12" class="m-0 p-0 pt-2">
        <h4 class="banner text-right">NEW ENERGY TECH - As melhores soluções para sua obra estão aqui !</h4>
      </b-col>
    </b-row>
    <b-row class="pb-2 back-bar full-width">
      <b-col cols="3" class="text-center p-0">
        <b-img :src="require('/static/images/logo_animada.svg')" width="230" />
      </b-col>
      <b-col cols="9" class="text-center p-0">
        <b-nav align="center">
          <b-nav-item class="set-bottom"><p class="no-color">Home</p></b-nav-item>
          <b-nav-item class="set-bottom"><p class="no-color">Sobre nós</p></b-nav-item>
          <b-nav-item class="set-bottom"><p class="no-color">O que fazemos</p></b-nav-item>
          <b-nav-item class="set-bottom"><p class="no-color">Nossa história</p></b-nav-item>
          <b-nav-item class="set-bottom"><p class="no-color">Consultar Certificação</p></b-nav-item>
          <b-nav-item class="set-bottom"><p class="no-color">Fale conosco</p></b-nav-item>
          <b-nav-item class="set-bottom" href="https://www.facebook.com/netech.new.energy.tech" target="_blank">
            <b-icon icon="facebook" variant="primary" scale="1.25"></b-icon>
          </b-nav-item>
          <b-nav-item class="set-bottom" href="https://www.instagram.com/netech.com.br/" target="_blank">
            <b-icon icon="instagram" variant="danger" scale="1.25"></b-icon>
          </b-nav-item>
          <b-nav-item class="set-bottom-logo">
            <b-img :src="require('/static/images/logo_sgcq_w.png')" width="80" @click="login()" />
          </b-nav-item>
        </b-nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "BarraNavegacaoPrincipal",

  data() {
    return {
      showNav: false,
    };
  },

  methods: {
    login() {
      this.$router.push({ path: "/login" });
    },
  }
});
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Neonderthaw&family=Russo+One&family=Whisper&display=swap");

.banner {
  font-family: "Russo One", sans-serif;
  font-weight: 400;
  font-style: normal;
}

.full-width {
  width: 100%;
}

.back-bar {
  margin: 0;
  min-height: 6rem;
  background-color: #003c5a;
}

.set-bottom {
  margin-top: 5rem;
}

.set-bottom-logo {
  margin-top: 4.5rem;
}

.no-color {
  color: white;
  font-size: 1.1rem;
}

.slide-right h4 {
  animation: slide-right 60s ease-in-out 2s infinite alternate;
}

@keyframes slide-right {
  0% {
    transform: translateX(-100%);
  }
  50% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-100%);
  }
}
</style>
